import { IMdlCustomDialogConfiguration, MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { Injectable } from '@angular/core';
import { CommonLinkEditorComponent, COMMON_LINK_EDITOR_OPTIONS } from './common-link-editor.component';
import { CommonLinkInfo } from './common-link-info';
import { Observable } from 'rxjs';

export interface CommonLinkEditorOptions {
    isNew: boolean;
    editedEntity: CommonLinkInfo;
}

@Injectable()
export class CommonLinksInfoEditor {

    constructor(private readonly mdlDialogService: MdlDialogService) { }

    public openToCreate(): Observable<MdlDialogReference> {
        const editorOptions: CommonLinkEditorOptions = {
            isNew: true,
            editedEntity: new CommonLinkInfo()
        };

        return this.openDialog(editorOptions);       
    }

    public openToEdit(editedCommonLink: CommonLinkInfo): Observable<MdlDialogReference> {
        const editorOptions: CommonLinkEditorOptions = {
            isNew: false,
            editedEntity: editedCommonLink
        };

        return this.openDialog(editorOptions);      
    }

    private openDialog(commonLinkEditorOptions: CommonLinkEditorOptions): Observable<MdlDialogReference> {
        const dialogConfig: IMdlCustomDialogConfiguration = {
            isModal: true,
            clickOutsideToClose: true,
            component: CommonLinkEditorComponent,
            styles: {
                'min-width': '280px'
            },
            providers: [
                {
                    provide: COMMON_LINK_EDITOR_OPTIONS,
                    useValue: commonLinkEditorOptions
                }
            ]
        };

        return this.mdlDialogService.showCustomDialog(dialogConfig);         
    }
}